import { z } from 'zod';

export default z.object({
  additional_space: z
    .object({
      top: z.coerce.number().default(() => 0),
      bottom: z.coerce.number().default(() => 0),
    })
    .default(() => ({ top: 0, bottom: 0 })),
});
